import React from 'react';
import { T } from '../components/helpful';
import HotelQuickInfo from '../components/hotelQuickInfo';
import { LangContext } from '../context/context';


/* The QuickInfo class is a React component that displays a HotelQuickInfo component with a pageTitle
of "Quick Information". 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default class QuickInfo extends React.Component {
    static contextType = LangContext;
    constructor(props) {
        super(props);

        this.state = {
            pageTitle: <T value={"Quick Information"} /> ,
           
        }; 

    } 
    
    render() {
        return (

            <div>
                <HotelQuickInfo title={ this.state.pageTitle} />
            </div>
        );

    }
}